import React from 'react';
import PropTypes from "prop-types";
import Button from '../Button';

const CardActionBox = props => {
  const { buttons, className, onClick } = props;

  const renderButtons = () => {
    if (buttons) {
      return buttons.map((button, index) => {
        return (
          <Button
            {...button}
            key={index}
            onClick={button.action}
          />
        )
      })
    }
  };

  return (
    <div className={className} onClick={onClick}>
      {buttons && renderButtons()}
    </div>
  );
}

CardActionBox.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      style: PropTypes.string,
      iconFamily: PropTypes.string,
      icon: PropTypes.string,
      label: PropTypes.string,
      disabled: PropTypes.bool,
      action: PropTypes.func
    })
  ).isRequired,
  className: PropTypes.string,
  hasChildren: PropTypes.bool,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(['top', 'middle']),
  type: PropTypes.oneOf(['extra-wide', 'wide', 'medium', 'narrow'])
};

CardActionBox.defaultProps = {
  position: 'top',
  type: 'wide'
}

export default CardActionBox;
